/**
 * クロス商品設定画面 対象クロス商品情報更新(リクエストパラメータ)用クラス
 *
 * @export TargetCrossGoodsInfo
 * @class TargetCrossGoodsInfo
 */
export class TargetCrossGoodsInfo {
  /**  受注コード */
  public orderCode = String('');
  /**  選択受注コード */
  public selectOrderCode = String('');
  /**  クロスコード */
  public crossCode = String('');
  /**  媒体区分 */
  public mediumType = String('');
  /**  Pコード */
  public pcode = String('');
}
